













































































































import { CourseTypeOption } from '@/jbi-shared/dto/jtms.dtos';
import { ModuleStatus } from '@/jbi-shared/types/jtms.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { capitalize } from '@/jbi-shared/util/string.utils';
import {
  ModuleFilterOptions,
  StatusOptions
} from '@/store/modules/jtms/module/module.types';
import { RootState } from '@/store/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({})
export default class ModuleSearch extends Vue {
  @Prop(Object) moduleFilterParams!: ModuleFilterOptions;

  selectedCourseTypeOption: CourseTypeOption = {
    id: 0,
    name: 'All Course Types'
  };

  selectedStatusOption: StatusOptions = {
    id: 0,
    status: capitalize(ModuleStatus.ACTIVE.toLowerCase())
  };

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeOption[]>;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeOption[];

  get courseTypeOptions() {
    if (this.courseTypes) {
      return this.courseTypes;
    }

    return [];
  }

  get statusOptions() {
    return Object.values(ModuleStatus).map((value, index) => ({
      id: index,
      status: capitalize(value.toLowerCase())
    }));
  }

  created() {
    this.getCourseTypes();
  }

  resetFilter() {
    return this.$emit('resetFilter');
  }

  @Watch('selectedCourseTypeOption')
  courseTypeSelected() {
    if (this.selectedCourseTypeOption.name === 'All Course Types') {
      this.moduleFilterParams.type = '';
      return;
    }

    this.moduleFilterParams.type = this.selectedCourseTypeOption.name;
  }

  @Watch('selectedStatusOption')
  statusSelected() {
    this.moduleFilterParams.status = this.selectedStatusOption.status;
  }

  @Watch('moduleFilterParams', { deep: true })
  @Debounce(300)
  public onChange() {
    // Reset filter values
    if (this.moduleFilterParams.type === '') {
      this.selectedCourseTypeOption = {
        id: 0,
        name: 'All Course Types'
      };
    }

    if (this.moduleFilterParams.status === '') {
      this.selectedStatusOption = {
        id: 0,
        status: capitalize(ModuleStatus.ACTIVE.toLowerCase())
      };
    }

    if (this.moduleFilterParams.type || this.moduleFilterParams.status) {
      this.$emit('input', this.moduleFilterParams);
    }
  }
}
